import { render, staticRenderFns } from "./ColaboradorStatusDisponibilidade.vue?vue&type=template&id=483b959f&scoped=true"
import script from "./ColaboradorStatusDisponibilidade.vue?vue&type=script&lang=js"
export * from "./ColaboradorStatusDisponibilidade.vue?vue&type=script&lang=js"
import style0 from "./ColaboradorStatusDisponibilidade.vue?vue&type=style&index=0&id=483b959f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b959f",
  null
  
)

export default component.exports